import { defineMessages } from "react-intl"
import { ColumnDefinition, ColumnDefinitionCategory, DataType, TotalType } from "."
import { ObjectType, ObjectTypeConfig } from ".."
import { PREFERENCE_TYPE } from "../../constants"
export enum AccountStatementsColumnIds {
    IDENTIFIER = "identifier",
    EFFECTIVE_DATE = "date",
    LOCATION_ID = "locationId",
}
const columnDefinitions: ColumnDefinition[] = [
    {
        id: AccountStatementsColumnIds.IDENTIFIER,
        sortId: "identifier",
        defaultSort: true,
        dataType: DataType.LINK,
        dataAttributes: {
            redirect: "/account-statements/{id}/edit"
        },
        totalAttributes: {
            key: "totalItemsCount",
            type: TotalType.STRING,
        },
        sortable: true,
        identifier: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
    },
    {
        id: AccountStatementsColumnIds.EFFECTIVE_DATE,
        dataType: DataType.DATE,
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT, ColumnDefinitionCategory.DATE_RELATED],
    },
    {
        id: AccountStatementsColumnIds.LOCATION_ID,
        dataType: DataType.OPTIONS,
        dataAttributes: {
            optionsKey: "locationOptions",
            loadingKey: "loadingLocationOptions",
            textAlign: "right",
        },
        sortable: true,
        defaultView: true,
        categories: [ColumnDefinitionCategory.DEFAULT],
        //hidden until statements can be assigned a location
        hidden: true,
    },
]
const headerMessages = defineMessages({
    [AccountStatementsColumnIds.IDENTIFIER]: {
        id: "generic-listing.account-statements.table-header.identifier",
        defaultMessage: "ID",
    },
    [AccountStatementsColumnIds.EFFECTIVE_DATE]: {
        id: "generic-listing.account-statements.table-header.date",
        defaultMessage: "Date",
    },
    [AccountStatementsColumnIds.LOCATION_ID]: {
        id: "generic-listing.account-statements.table-header.location-name",
        defaultMessage: "Location",
    },
})
const configuration: ObjectTypeConfig = {
    objectType: ObjectType.ACCOUNT_STATEMENTS,
    columnDefinitions,
    headerMessages,
    listingPreferencesKey: PREFERENCE_TYPE.LISTING_ACCOUNT_STATEMENTS,
    searchPlaceholder: {
        id: "generic-listing.account-statements.search-placeholder",
        defaultMessage: "Search a statement...",
    },
    displayString: {
        id: "generic-listing.account-statements.display-string",
        defaultMessage: "Account statements",
    },
    searchObjectType: ObjectType.ACCOUNT_STATEMENTS,
    bulkActionDefinitions: [],
    creationButtonComponent: require("../../../../common/listing/generic-listing/creation-buttons/AccountStatementCreationButton"),
}
export default configuration


// WEBPACK FOOTER //
// ./src/state/listing/generic-listing/column-definitions/account-statements.ts